import { Router } from 'pjax';
import form from './form.js';
import index from './index.js';

Router.get('round/:any', form);
Router.get('round', index);
